import { z } from "zod";
import { ZObb3DWorldMm } from "./mcbim.schema";
export const ZMcBimItem3d = z.object({
    _id: z.unknown().optional(),
    globalId: z.string().optional(),
    name: z.string().optional(),
    instanceClass: z.string().optional(),
    geometry: z
        .object({
        Obb3DWorldMmList: z.array(ZObb3DWorldMm).optional(),
    })
        .optional(),
});
